module.exports = __webpack_public_path__ + "static/img/xAxis.966dc4ae.svg";